import React from "react";
import { Select } from "antd";
import * as R from "ramda";

import AntdTag from "../feedback/Tag";

const Tag = ({ onChange, value, tags = [], ...props }) => {
  function handleChange(value) {
    onChange(value ? R.head(value) : undefined);
  }

  return value ? (
    <AntdTag
      closable
      onClose={() => onChange(undefined)}
      style={{ width: "fit-content" }}
      {...props}
    >
      {value}
    </AntdTag>
  ) : (
    <Select allowClear mode="tags" onChange={handleChange} {...props}>
      {tags.map(tag => (
        <Select.Option key={tag}>{tag}</Select.Option>
      ))}
    </Select>
  );
};

export default Tag;
